import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class CheckPlatformService {
  constructor(
    @Inject(PLATFORM_ID)
    private platformId: Object
  ) {}

  private _isPlatformBrowser?: boolean;
  public get isPlatformBrowser() {
    if (!this._isPlatformBrowser) {
      this._isPlatformBrowser = isPlatformBrowser(this.platformId);
    }
    return this._isPlatformBrowser;
  }

  private _isTouchDevice?: boolean | number;
  public get isTouchDevice() {
    if (!this.isPlatformBrowser) return false;
    if (!this._isTouchDevice) {
      this._isTouchDevice =
        'ontouchstart' in window || navigator.maxTouchPoints;
    }
    return this._isTouchDevice;
  }

  private _iOS?: boolean;
  public get iOS() {
    if (!this.isPlatformBrowser) return false;
    if (!this._iOS) {
      this._iOS =
        [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod',
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    }
    return this._iOS;
  }
}
